<fieldset [formGroup]="pilotLogEntry">
  <legend>{{ pilot.firstName }} {{ pilot.lastName }}: Flights and Landings</legend>
  <div data-row-span="10">
    <ng-container *ngIf="features.approachDepartures">
      <div data-field-span="1" class="readonly">
        <label>Approaches</label>
        <input type="number" readonly [value]="approachCount$ | async" />
      </div>
      <div data-field-span="2">
        <label>Approaches Types</label>
        <fl-multi-quantity-select
          [options]="approachOptions"
          [formArray]="approaches"
        ></fl-multi-quantity-select>
      </div>
      <div data-field-span="1" class="readonly">
        <label>Departures</label>
        <input type="number" disabled readonly [value]="departureCount$ | async" />
      </div>
      <div data-field-span="2">
        <label>Departure Types</label>
        <fl-multi-quantity-select
          [options]="departureOptions"
          [formArray]="departures"
        ></fl-multi-quantity-select>
      </div>
    </ng-container>
    <ng-container *ngIf="isFixedWing$ | async">
      <div data-field-span="2" [flValidationState]="blockTime">
        <label>Block Time</label>
        <input type="number" [formControl]="blockTime" min="0" />
      </div>
    </ng-container>
  </div>
  <div data-row-span="10" formGroupName="landings">
    <div data-field-span="2" flValidationState="day">
      <label>Day Landings</label>
      <input type="number" step="1" min="0" formControlName="day" />
    </div>
    <div data-field-span="2" title="Night Landings" flValidationState="night">
      <label>Night Landings</label>
      <input type="number" step="1" min="0" formControlName="night" />
    </div>
    <div
      data-field-span="2"
      title="HNVGO"
      [flValidationState]="pilotLogEntry.get('hnvgo')"
      *ngIf="isSimple || (isRotorWing$ | async)"
    >
      <label>HNVGO</label>
      <input type="number" step="1" min="0" [formControl]="pilotLogEntry.get('hnvgo')" />
    </div>
    <div
      data-field-span="2"
      title="Run On Landings"
      flValidationState="runOn"
      *ngIf="isRotorWing$ | async"
    >
      <label>Run On</label>
      <input type="number" min="0" step="1" formControlName="runOn" />
    </div>
  </div>

  <div data-row-span="10" formGroupName="flightHours">
    <div data-field-span="1" flValidationState="day">
      <label>Day Hrs.</label>
      <input type="number" formControlName="day" min="0" />
    </div>
    <div data-field-span="2" title="Night Time Unaided" flValidationState="nightUnaided">
      <label>Night Unaided Hrs.</label>
      <input type="number" formControlName="nightUnaided" min="0" />
    </div>
    <div data-field-span="1" title="Night Time Aided" flValidationState="nightAided">
      <label>Night Aided Hrs.</label>
      <input type="number" formControlName="nightAided" min="0" />
    </div>
    <div data-field-span="1" flValidationState="part135" *ngIf="features.part135part91">
      <label>Pt 135</label>
      <input type="number" formControlName="part135" min="0" />
    </div>
    <div data-field-span="1" flValidationState="part91" *ngIf="features.part135part91">
      <label>Pt 91</label>
      <input type="number" formControlName="part91" min="0" />
    </div>
    <div data-field-span="1" *ngIf="formHelper.isPart133$ | async" class="readonly">
      <label>Pt 133</label>
      <input type="number" [readonly]="true" formControlName="part133" min="0" />
    </div>
    <div data-field-span="1" flValidationState="ifrImc">
      <label>IFR IMC</label>
      <input type="number" formControlName="ifrImc" min="0" />
    </div>
    <div data-field-span="1" flValidationState="ifrSim">
      <label>IFR Sim</label>
      <input type="number" formControlName="ifrSim" min="0" />
    </div>
    <div data-field-span="2" title="IFR Practice Approaches" *ngIf="features.ifrPracticeOnly">
      <label>IFR Practice Approaches</label>
      <fl-multi-quantity-control
        value="IFR_Practice"
        [formArray]="approaches"
      ></fl-multi-quantity-control>
    </div>
  </div>
  <div data-row-span="10" formGroupName="flightHours" *ngIf="formHelper.isPart133$ | async">
    <div data-field-span="2">
      <label>
        <strong>Hook</strong>
      </label>
      <input type="text" disabled readonly />
    </div>
    <div data-field-span="1" flValidationState="part133HookDayHours">
      <label>Day Hrs.</label>
      <input type="number" formControlName="part133HookDayHours" min="0" />
    </div>
    <div data-field-span="1" flValidationState="part133HookNightHours">
      <label>Night Hrs.</label>
      <input type="number" formControlName="part133HookNightHours" min="0" />
    </div>
    <div data-field-span="6"></div>
  </div>
  <div data-row-span="10" formGroupName="flightHours" *ngIf="formHelper.isPart133$ | async">
    <div data-field-span="2">
      <label>
        <strong>Hoist</strong>
      </label>
      <input type="text" disabled readonly />
    </div>
    <div data-field-span="1" flValidationState="part133HoistDayHours">
      <label>Day Hrs.</label>
      <input type="number" formControlName="part133HoistDayHours" min="0" />
    </div>
    <div data-field-span="1" flValidationState="part133HoistNightHours">
      <label>Night Hrs.</label>
      <input type="number" formControlName="part133HoistNightHours" min="0" />
    </div>
    <div data-field-span="6"></div>
  </div>
</fieldset>

<fl-message-box [messages]="validationErrors$ | async" [level]="'error'"></fl-message-box>
<br />
<!--
  <pre>
    Pilot Log Entry:
    {{validationState$ | async | json }}
  </pre>
-->
